import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/home/Home.vue'
import Login from '@/views/login/Login.vue'
import Pick from '@/views/pick/index.vue'
import Subject from '@/views/subject/index.vue'
import Config from '@/views/config/index.vue'

const routes = [
  {
    path: '/',
    name: '首页',
    component: Home,
    children: [{
      path: '/subject',
      name: '题库管理',
      component: Subject
    },{
      path: '/pick',
      name: '获奖管理',
      component: Pick
    },{
      path: '/config',
      name: '获奖配置',
      component: Config
    }]
  },
  {
    path: '/login',
    name: '登录',
    component: Login
  }
]

const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
